var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.287109 1.94043C0.287109 1.50945 0.458314 1.09613 0.763061 0.791381C1.06781 0.486635 1.48113 0.31543 1.91211 0.31543H7.32878C7.75975 0.31543 8.17308 0.486635 8.47782 0.791381C8.78257 1.09613 8.95378 1.50945 8.95378 1.94043V10.6223C8.95378 11.2831 8.20628 11.6677 7.66894 11.2836L4.62044 9.10614L1.57194 11.2836C1.03407 11.6682 0.287109 11.2836 0.287109 10.6228V1.94043Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardAtivo);
export default __webpack_public_path__ + "static/media/IconCardAtivo.3a5f26c38780018d1773100589a72ca4.svg";
export { ForwardRef as ReactComponent };